import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const LoopsBomber = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.jackets.LoopsBomber.itemName}
      name={AW23.jackets.LoopsBomber.itemName}
      price={AW23.jackets.LoopsBomber.itemPrice}
      fabric={AW23.jackets.LoopsBomber.itemFabric}
      src={AW23.jackets.LoopsBomber.sizeChart}
      divId={AW23.jackets.LoopsBomber.shopifyDivId}
      mainId={AW23.jackets.LoopsBomber.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.jackets.LoopsBomber.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.jackets.LoopsBomber.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default LoopsBomber;
